import customAxios from "../../../http/customAxios";

export type GetRevenuesByReservationQueryResult = {
  hotelTicker: string;
  totalReservations: number;
  totalRevenue: number;
};

type GetRevenuesByReservationQueryRequest = {
  startDate: string;
  endDate: string;
  hotelTickers: string[];
};

export async function getRevenuesByReservation(
  queryExecutorApiEndpoint: string,
  { startDate, endDate, hotelTickers }: GetRevenuesByReservationQueryRequest
): Promise<GetRevenuesByReservationQueryResult[]> {
  const queryJSON = {
    sql: `
      SELECT hotelTicker, COUNT(*) as totalReservations, SUM(amount) as totalRevenue
      FROM reports.booking
      WHERE hotelTicker in (@hotelTickers)
        AND bookingDate BETWEEN @startDate AND @endDate
        AND status = @status
      GROUP BY hotelTicker
    `,
    onlyLiveProperties: false,
    excludeChains: false,
    context: {
      "@hotelTickers": hotelTickers,
      "@startDate": startDate,
      "@endDate": endDate,
      "@status": "reserva",
    },
  };
  const response = await customAxios.post<{ result: GetRevenuesByReservationQueryResult[] }>(
    queryExecutorApiEndpoint,
    queryJSON
  );
  return response.data.result;
}
